export default {
  buttons: {
    update_meal: 'Update meal deal',
  },
  error_messages: {
    missing_fields: 'Please select all required fields.',
    product_unavailable: 'Sold out!',
  },
};
